import React from 'react';
import { UseSearchFieldStatesReturn } from '@/features/ban-hang/cong-no-khach-hang/so-chi-tiet-cong-no-nhieu-khach-hang/hooks';
import { SearchFieldV2 as SearchField, FormFieldV2 as FormField, DateRangeDropdownV2 } from '@/components/custom/erp';
import { accountSearchColumns } from '@/constants/search-columns';
import { QUERY_KEYS } from '@/constants/query-keys';
import { Label } from '@/components/ui/label';
import { TaiKhoan } from '@/types/schemas';

interface BasicInfoProps {
  searchFieldStates: UseSearchFieldStatesReturn;
}

const BasicInfo: React.FC<BasicInfoProps> = ({ searchFieldStates }) => {
  return (
    <div className='space-y-2 p-4'>
      <div className='flex flex-col space-y-3'>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Ngày hạch toán từ/đến:</Label>
          <div>
            <DateRangeDropdownV2
              fromDateName='ngay_ct1'
              toDateName='ngay_ct2'
              toFieldClassName='w-48'
              fromFieldClassName='w-48'
            />
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Tài khoản:</Label>
          <SearchField<TaiKhoan>
            type='text'
            searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
            searchColumns={accountSearchColumns}
            dialogTitle='Danh mục tài khoản'
            columnDisplay='code'
            displayRelatedField='name'
            onRowSelection={searchFieldStates.setAccount}
            className='w-full'
            classNameRelatedField='w-auto min-w-[300px] max-w-full'
          />
        </div>
        <div className='flex items-center'>
          <FormField
            name='ct_vt'
            className='w-[400px]'
            label='Chi tiết theo vật tư'
            labelClassName='w-40'
            type='checkbox'
          />
        </div>
      </div>
    </div>
  );
};

export default BasicInfo;
